export const spriteUrl = "/assets/sprites/icons-elvent.KIPJ5LAvqT9ai2aFK2NQXg.svg"

export type IconName =
  | "package-return"
  | "badge"
  | "bollerwagen-scooter"
  | "delivery"
  | "check-rounded-filled"
  | "party-popper"
  | "percent-rounded-filled"
  | "thumbs-up"
  | "voucher"
